// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PriceSplitUp-pricingSplitUpBoxTopRadius-bfBvQ {
    border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.PriceSplitUp-pricingSplitUpBoxBottomRadius-x0nKX {
    border-radius: 0 0 var(--radius-3) var(--radius-3);
}

.PriceSplitUp-pricingSplitUpInnerFlexWrapper-ybexo,
.PriceSplitUp-pricingSplitUpFlexWrapper-n7rr2 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    grid-gap: 12px;
}

.PriceSplitUp-pricingSplitUpFlexWrapper-n7rr2 {
    margin-top: 12px;
}

.PriceSplitUp-pricingSplitUpFlexWrapper-n7rr2:first-child {
    margin-top: 0;
}

.PriceSplitUp-pricingSplitUpInnerFlexWrapper-ybexo {
    margin-top: 6px;
}

.PriceSplitUp-pricingSplitUpTitle-AoLRL,
.PriceSplitUp-pricingSplitUpAccordionHeading-m9HC0 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    grid-gap: 6px;
    width: 100%;
    max-width: 60%;
    text-align: start;
}

.PriceSplitUp-pricingSplitUpTitleBaseline-vfAg8 {
    -webkit-box-align: baseline !important;
        -ms-flex-align: baseline !important;
            align-items: baseline !important;
}

.PriceSplitUp-pricingSplitUpTitle-AoLRL+span,
.PriceSplitUp-pricingSplitUpAccordionHeading-m9HC0+span,
.PriceSplitUp-additionPricingSplitUpTitle-uCwl7+span {
    width: 100%;
    max-width: 40%;
    text-align: end;
}

.PriceSplitUp-pricingSplitUpTitle-AoLRL img {
    position: relative;
    top: 2px;
}

.PriceSplitUp-priceSplitUpLoaderContainer-hO6xP {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 50px 0;
}

.PriceSplitUp-pricingSplitUpDiscountAmount-Wcs8H {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
}

.PriceSplitUp-pricingSplitUpNoMargin-bwd9f {
    margin-top: 0;
}

.PriceSplitUp-additionPricingSplitUpTitle-uCwl7 {
    width: 100%;
    max-width: 60%;
    text-align: start;
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetail/PriceDetails/PriceSplitUp/PriceSplitUp.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sCAAgC;QAAhC,mCAAgC;YAAhC,gCAAgC;AACpC;;AAEA;;;IAGI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".pricingSplitUpBoxTopRadius {\n    border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.pricingSplitUpBoxBottomRadius {\n    border-radius: 0 0 var(--radius-3) var(--radius-3);\n}\n\n.pricingSplitUpInnerFlexWrapper,\n.pricingSplitUpFlexWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.pricingSplitUpFlexWrapper {\n    margin-top: 12px;\n}\n\n.pricingSplitUpFlexWrapper:first-child {\n    margin-top: 0;\n}\n\n.pricingSplitUpInnerFlexWrapper {\n    margin-top: 6px;\n}\n\n.pricingSplitUpTitle,\n.pricingSplitUpAccordionHeading {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    grid-gap: 6px;\n    width: 100%;\n    max-width: 60%;\n    text-align: start;\n}\n\n.pricingSplitUpTitleBaseline {\n    align-items: baseline !important;\n}\n\n.pricingSplitUpTitle+span,\n.pricingSplitUpAccordionHeading+span,\n.additionPricingSplitUpTitle+span {\n    width: 100%;\n    max-width: 40%;\n    text-align: end;\n}\n\n.pricingSplitUpTitle img {\n    position: relative;\n    top: 2px;\n}\n\n.priceSplitUpLoaderContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 50px 0;\n}\n\n.pricingSplitUpDiscountAmount {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.pricingSplitUpNoMargin {\n    margin-top: 0;\n}\n\n.additionPricingSplitUpTitle {\n    width: 100%;\n    max-width: 60%;\n    text-align: start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pricingSplitUpBoxTopRadius": `PriceSplitUp-pricingSplitUpBoxTopRadius-bfBvQ`,
	"pricingSplitUpBoxBottomRadius": `PriceSplitUp-pricingSplitUpBoxBottomRadius-x0nKX`,
	"pricingSplitUpInnerFlexWrapper": `PriceSplitUp-pricingSplitUpInnerFlexWrapper-ybexo`,
	"pricingSplitUpFlexWrapper": `PriceSplitUp-pricingSplitUpFlexWrapper-n7rr2`,
	"pricingSplitUpTitle": `PriceSplitUp-pricingSplitUpTitle-AoLRL`,
	"pricingSplitUpAccordionHeading": `PriceSplitUp-pricingSplitUpAccordionHeading-m9HC0`,
	"pricingSplitUpTitleBaseline": `PriceSplitUp-pricingSplitUpTitleBaseline-vfAg8`,
	"additionPricingSplitUpTitle": `PriceSplitUp-additionPricingSplitUpTitle-uCwl7`,
	"priceSplitUpLoaderContainer": `PriceSplitUp-priceSplitUpLoaderContainer-hO6xP`,
	"pricingSplitUpDiscountAmount": `PriceSplitUp-pricingSplitUpDiscountAmount-Wcs8H`,
	"pricingSplitUpNoMargin": `PriceSplitUp-pricingSplitUpNoMargin-bwd9f`
};
module.exports = ___CSS_LOADER_EXPORT___;
